'use strict';

angular.module('theme').directive('priceList', function ($window, $cookies, CartService, ArticleService, TrackerService) {
	return {
		restrict: 'A',
		templateUrl: 'component/price-list.html',
		scope: {
			productId: '@',
			//priceDiscount: '<',
			rowClass: '@',
			showOrderBtn: '@'
		},
		controller: function ($scope) {
			if ($cookies.get('campaign-code-discount')) {
				var discount = JSON.parse($cookies.get('campaign-code-discount'));
	
				if (!discount || discount.code === '') return;
	
				if (discount.type === 'Percent') {
					$scope.percentDiscount = Math.abs(discount.value) / 100;
				} else if(discount.amount) {
					var value = Math.abs(discount.amount);
					
					if (value == 0) return;
	
					$scope.discount = value;
				}
			}

			ArticleService.getProduct($scope.productId).then(function (product) {
				$scope.product = product;

				// Create 8 rows even if the result isn't
				var portions = 6;
				$scope.prices = _.range(1, portions+1).map(function (i) {
					return _.find(product.prices, {number: i}) || {number: i};
				});
			});

			$scope.select = function (servings) {
				CartService.add($scope.product, servings).then(function () {
					TrackerService.addToCart($scope.product);

					// redirect to cart
					$window.location.href = '/order/';
				});
			};
		}
	};
});
